import { render, staticRenderFns } from "./AppHtmlContentBlock.vue?vue&type=template&id=12b67651&scoped=true"
import script from "./AppHtmlContentBlock.vue?vue&type=script&lang=js"
export * from "./AppHtmlContentBlock.vue?vue&type=script&lang=js"
import style0 from "./AppHtmlContentBlock.vue?vue&type=style&index=0&id=12b67651&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b67651",
  null
  
)

export default component.exports